import { render, staticRenderFns } from "./CafeteriaViewLogs.vue?vue&type=template&id=a3d59308"
import script from "./CafeteriaViewLogs.vue?vue&type=script&lang=js"
export * from "./CafeteriaViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports